module.exports = __webpack_public_path__ + "static/media/OldStyleRadiator.1513cf56.png";